import { api } from '@/lib/api';
import type {
  HomepageMetricGroupKey,
  IApiResponse,
  ICreateHomepageMetricGroupRequest,
  IHomepageMetricGroup,
  IHomepageMetricGroupUpdate,
} from '@skystone/shared';

export const metricGroupApi = {
  getAll: async (): Promise<IHomepageMetricGroup[]> => {
    const result = await api.get<IApiResponse<IHomepageMetricGroup[]>>('/metric-groups');
    return result.data;
  },
  update: async (
    groupKey: HomepageMetricGroupKey,
    body: IHomepageMetricGroupUpdate,
  ): Promise<IHomepageMetricGroup> => {
    const result = await api.put<IApiResponse<IHomepageMetricGroup>>(
      `/metric-groups/${groupKey}`,
      body,
    );
    return result.data;
  },
  create: async (
    body: ICreateHomepageMetricGroupRequest,
  ): Promise<IHomepageMetricGroup> => {
    const result = await api.post<IApiResponse<IHomepageMetricGroup>>(
      '/metric-groups',
      body,
    );
    return result.data;
  },
};
